<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <!-- <li class="nav-item" v-if="getMenu.includes('Dashboard')"> -->
      <li class="nav-item">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Dashboard'"
        >
          <template v-slot:icon>
            <i class="ni ni-tv-2 text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Announcement')">
        <sidenav-item
          url="/announcement"
          :class="getRoute() === 'announcement' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'لوحة القيادة' : 'Announcement'"
        >
          <template v-slot:icon>
            <i class="fa fa-bullhorn text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Request For Quotation')">
        <sidenav-item
          url="/rfq"
          :class="getRoute() === 'rfq' ? 'active' : ''"
          navText="Request For Quotation"
        >
          <template v-slot:icon>
            <i
              class="ni ni-single-copy-04 text-warning text-sm opacity-10"
            ></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Purchase Order')">
        <sidenav-item
          url="/purchase-order"
          :class="getRoute() === 'purchase-order' ? 'active' : ''"
          navText="Purchase Order"
        >
          <template v-slot:icon>
            <i class="ni ni-credit-card text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Forecast Monthly')">
        <sidenav-item
          url="/forecast-monthly"
          :class="getRoute() === 'forecast-monthly' ? 'active' : ''"
          navText="Forecast Monthly"
        >
          <template v-slot:icon>
            <i class="fa fa-rss text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Daily Delivery')">
        <sidenav-item
          url="/delivery"
          :class="getRoute() === 'delivery' ? 'active' : ''"
          navText="Daily Delivery"
        >
          <template v-slot:icon>
            <i class="fa fa-truck text-primary text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Kanban')">
        <sidenav-item
          url="/kanban"
          :class="getRoute() === 'kanban' ? 'active' : ''"
          navText="Kanban"
        >
          <template v-slot:icon>
            <i class="fa fa-list text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Quality Performance')">
        <sidenav-item
          url="/qpr"
          :class="getRoute() === 'qpr' ? 'active' : ''"
          navText="Quality Performance"
        >
          <template v-slot:icon>
            <i class="fa fa-check-circle-o text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Certificate of Invoice')">
        <sidenav-item
          url="/certificate"
          :class="getRoute() === 'certificate' ? 'active' : ''"
          navText="Certificate of Invoice"
        >
          <template v-slot:icon>
            <i class="ni ni-paper-diploma text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="mt-3 nav-item">
        <h6
          class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2"
        >
          ACCOUNT PAGES
        </h6>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/profile"
          :class="getRoute() === 'profile' ? 'active' : ''"
          navText="Profile"
        >
          <template v-slot:icon>
            <i class="ni ni-single-02 text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <sidenav-item
          url="/notifications"
          :class="getRoute() === 'notifications' ? 'active' : ''"
          navText="Notifications"
        >
          <template v-slot:icon>
            <i class="fa fa-bell text-dark text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="getMenu.includes('Supplier Evaluation')">
        <sidenav-item
          url="/vendor-performance"
          :class="getRoute() === 'vendor-performance' ? 'active' : ''"
          navText="Supplier Evaluation"
        >
          <template v-slot:icon>
            <i class="fa fa-line-chart text-info text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item">
        <a href="#" class="nav-link" @click="logout">
          <div
            class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center"
          >
            <i class="fa fa-sign-out text-danger text-sm opacity-10"></i>
          </div>
          <span
            class="nav-link-text ms-1'"
            >Sign Out</span
          >
        </a>
      </li>
    </ul>
  </div>
  <!-- <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div> -->
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
// import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active"
    };
  },
  components: {
    SidenavItem,
    // SidenavCard
  },
  computed: {
    getMenu() {
      var result = []
      var menus = JSON.parse(localStorage.getItem('menu'))
      if (menus) {
        if (menus.data) {
          menus.data.forEach(item => {
            result.push(item.menu)  
          });
        }
      }
      return result
    }
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    logout() {
      this.$store.dispatch('setLoginState', false)
      localStorage.removeItem('isLogin')
      localStorage.removeItem('token')
      localStorage.removeItem('name')
      localStorage.removeItem('partner_id')
      localStorage.removeItem('partner_code')
      localStorage.removeItem('partner_vat')
      localStorage.removeItem('menu')
      localStorage.removeItem('partner_user_id')
      localStorage.removeItem('partner_user_name')

      this.$router.replace('/signin')
    }
  }
};
</script>
